import React from 'react';
import { Document, Page, Text, View, StyleSheet,Image } from '@react-pdf/renderer';
import moment from 'moment';
import MonkCapital from "../../../../src/images/monkCapital.png";
// --- STYLES ---
// I've refined the styles for better layout and to fix wrapping issues.
const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 9,
    paddingTop: 70, // Increased to ensure space for fixed header
    paddingBottom: 60, // Increased to ensure space for fixed footer
    paddingHorizontal: 35,
    backgroundColor: '#ffffff',
  },
  header: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: 'white',
    paddingHorizontal: 35,
    height: 50,
  },
  headerLogo: { height:50,width:120},
  headerTitle: { fontFamily: 'Helvetica-Bold', fontSize: 14 ,color:"#000000"},
  footerTitle: { fontFamily: 'Helvetica-Bold', fontSize: 10 ,color:"#000000"},
  footer: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#FFF8F4',
    padding: 10,
    height: 40,
    flexDirection: 'row',
    justifyContent: 'space-around',
    alignItems: 'center',
    color: 'white',
    fontSize: 9,
  },
  sectionTitle: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 13,
    color: '#333',
    backgroundColor:"#FFF8F4",
    padding:10
  },
  sectionTitle1: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 13,
    color: '#333',
    backgroundColor:"#FFF8F4", 
    padding:10
  },
  customerInfoBox: {
    border: '0.5px solid #FFEFE2',
    padding: 10,
    marginBottom: 20,
    backgroundColor:"#FFF8F4"
  },
  infoRow: { flexDirection: 'row', marginBottom: 5 },
  infoColLeft: { width: '50%', flexDirection: 'row',padding:7 },
  infoColRight: { width: '50%', flexDirection: 'row',padding:7 },
  infoLabel: { width: 95, fontFamily: 'Helvetica' },
  infoValue: { fontFamily: 'Helvetica-Bold', flex: 1 },
  addressRow: { flexDirection: 'row' ,padding:7},
  addressValue: { fontFamily: 'Helvetica-Bold', flex: 1 },
  
  loanDetailsContainer: {
    backgroundColor:"#FCFEFF"
  },
  lenderName: {
    fontFamily: 'Helvetica-Bold',
    fontSize: 10,
    padding:10
  },
  loanDetailsRow: {
    flexDirection: 'row',
    fontSize: 10,
  },
  loanDetailsCol: {
    width: '50%',
    flexDirection: 'row',
    marginBottom: 8,
    padding:10
  },
  loanDetailsLabel: {
    width: 180,
    fontFamily: 'Helvetica',
  },
  loanDetailsValue: {
    fontFamily: 'Helvetica-Bold',
  },

  // --- REVISED TABLE STYLES ---
  table: { 
    display: "table", 
    width: "auto", 
    marginTop: 10,
  },
  tableRow: { 
    flexDirection: "row", 
    alignItems: 'center',
    // Removed minHeight to allow rows to grow with content
  },
  tableHeader: { 
  },
  tableCol: { 
    // Styling for the <View> that acts as a cell
    paddingVertical: 5, // Vertical padding for all cells
    paddingHorizontal: 3, // Horizontal padding for all cells
    backgroundColor:"#FFF8F4",
    margin:1
  },
    tableCol1: { 
    // Styling for the <View> that acts as a cell
    paddingVertical: 5, // Vertical padding for all cells
    paddingHorizontal: 3, // Horizontal padding for all cells
    margin:1
  },
  tableCellText: { 
    // Styling for the <Text> inside a cell
    fontSize: 6, // Slightly reduced for better fit
    textAlign: 'center',
  },
  tableHeaderText: {
    fontFamily: 'Helvetica-Bold',
  },
  
  // Revised Column Widths for better distribution
  colSrNo: { width: '5%' },
  colDate: { width: '8%' }, // Increased width
  colPrincipal: { width: '7%' },
  colInterest: { width: '6%' },
  colFee: { width: '4.5%' },
  colPenalty: { width: '5%' },
  colTotalPaid: { width: '8%' },
  colRemainingDue: { width: '8%' },
  colPrincipalOut: { width: '8%' }, // Increased width

  // --- TERMS & CONDITIONS STYLES ---
  termsSection: { 
    marginTop: 20,
    // Use the `break` prop to suggest a page break before this section if it's near the bottom of a page
    // This prevents having just the "Terms & Conditions" title at the end of a page.
    break: true, 
  },
  termsTitle: { fontFamily: 'Helvetica-Bold', fontSize: 11, marginBottom: 8 },
  termsText: { fontSize: 8, textAlign: 'justify', lineHeight: 1.5, marginBottom: 5 },
  termsBold: { fontFamily: 'Helvetica-Bold' }
});

// Reusable components for header, footer, and table parts

const Header = () => (
    <View style={styles.header} fixed>
      <Image style={styles.headerLogo} src={MonkCapital} />
      <Text style={styles.headerTitle}>Monk Capital Private Limited</Text>
    </View>
);
  
const Footer = () => (
    <View style={styles.footer} fixed>
        <Text style={styles.footerTitle}>www.feemonk.com</Text>
        <Text style={styles.footerTitle}>+91 95131 68846</Text>
        <Text style={styles.footerTitle}>hello@feemonk.com</Text>
    </View>
);

const TableHeader = () => (
    <View style={[styles.tableRow, styles.tableHeader]} fixed>
      <View style={[styles.tableCol1, styles.colSrNo]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Emi No.</Text></View>
      <View style={[styles.tableCol1, styles.colDate]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Due Date</Text></View>
      <View style={[styles.tableCol1, styles.colPrincipal]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Principal Due</Text></View>
      <View style={[styles.tableCol1, styles.colPrincipal]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Principal Paid</Text></View>
      <View style={[styles.tableCol1, styles.colInterest]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Interest Due</Text></View>
      <View style={[styles.tableCol1, styles.colInterest]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Interest Paid</Text></View>
      <View style={[styles.tableCol1, styles.colInterest]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Interest Waived</Text></View>
      <View style={[styles.tableCol1, styles.colFee]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Fee Due</Text></View>
      <View style={[styles.tableCol1, styles.colFee]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Fee Paid</Text></View>
      <View style={[styles.tableCol1, styles.colPenalty]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Penalty Due</Text></View>
      <View style={[styles.tableCol1, styles.colPenalty]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Penalty Paid</Text></View>
      <View style={[styles.tableCol1, styles.colPenalty]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Penalty Waived</Text></View>
      <View style={[styles.tableCol1, styles.colTotalPaid]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Total Paid</Text></View>
      <View style={[styles.tableCol1, styles.colRemainingDue]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Remaining Due</Text></View>
      <View style={[styles.tableCol1, styles.colDate]}><Text style={[styles.tableCellText, styles.tableHeaderText]}>Paid Date</Text></View>
    </View>
);

const TableRow = ({ item }) => (
    <View style={styles.tableRow} wrap={false}>
      <View style={[styles.tableCol, styles.colSrNo]}><Text style={styles.tableCellText}>{item.emiNo}</Text></View>
      <View style={[styles.tableCol, styles.colDate]}><Text style={styles.tableCellText}>{item.dueDate}</Text></View>
      <View style={[styles.tableCol, styles.colPrincipal]}><Text style={styles.tableCellText}>{item.principleAmount}</Text></View>
      <View style={[styles.tableCol, styles.colPrincipal]}><Text style={styles.tableCellText}>{item.paidPrinciple}</Text></View>
      <View style={[styles.tableCol, styles.colInterest]}><Text style={styles.tableCellText}>{item.interestAmount}</Text></View>
      <View style={[styles.tableCol, styles.colInterest]}><Text style={styles.tableCellText}>{item.paidInterest}</Text></View>
      <View style={[styles.tableCol, styles.colInterest]}><Text style={styles.tableCellText}>{(item.status === 1 || item.status === 5 ) ? 0:item.interestAmount - item.paidInterest}</Text></View>
      <View style={[styles.tableCol, styles.colFee]}><Text style={styles.tableCellText}>0</Text></View>
      <View style={[styles.tableCol, styles.colFee]}><Text style={styles.tableCellText}>0</Text></View>
      <View style={[styles.tableCol, styles.colPenalty]}><Text style={styles.tableCellText}>{item?.overdueCharges + item?.bounceCharges}</Text></View>
      <View style={[styles.tableCol, styles.colPenalty]}><Text style={styles.tableCellText}>{item?.paidBounceCharges + item?.paidOverdue}</Text></View>
      <View style={[styles.tableCol, styles.colPenalty]}><Text style={styles.tableCellText}>{item?.discount}</Text></View>
      <View style={[styles.tableCol, styles.colTotalPaid]}><Text style={styles.tableCellText}>{item?.repaidEmiAmount}</Text></View>
      <View style={[styles.tableCol, styles.colRemainingDue]}><Text style={styles.tableCellText}>{item?.remainingAmountToBePaid}</Text></View>
      <View style={[styles.tableCol, styles.colDate]}><Text style={styles.tableCellText}>{item?.emiRepaidDate === "Invalid date"?"-":item?.emiRepaidDate}</Text></View>
    </View>
);

const Statement = ({ data }) => {
    const { customerInfo, loanDetails, statementData } = data;
  
    return (
      <Document>
        {/* All content is placed within a single Page component. 
            React-PDF will handle creating new pages automatically. */}
        <Page size="A4" style={styles.page}>
          <Header />
          
          <Text style={{ textAlign: 'right', fontSize: 10, marginBottom: 15 }}>
            Statement Generation Date : {moment().format("DD-MM-YYYY hh:mm:ss A")}
          </Text>
          
          <View style={styles.customerInfoBox}>
            <View style={styles.infoRow}>
                <View style={styles.infoColLeft}><Text style={styles.infoLabel}>Customer Name:</Text><Text style={styles.infoValue}>{customerInfo.customerName}</Text></View>
                <View style={styles.infoColRight}><Text style={styles.infoLabel}>Loan ID:</Text><Text style={styles.infoValue}>{customerInfo.loanId}</Text></View>
            </View>
            <View style={styles.infoRow}>
                <View style={styles.infoColLeft}><Text style={styles.infoLabel}>Application Date:</Text><Text style={styles.infoValue}>{customerInfo.applicationDate}</Text></View>
                <View style={styles.infoColRight}><Text style={styles.infoLabel}>Disbursal date:</Text><Text style={styles.infoValue}>{customerInfo.disbursalDate}</Text></View>
            </View>
            <View style={styles.infoRow}>
                <View style={styles.infoColLeft}><Text style={styles.infoLabel}>Email:</Text><Text style={styles.infoValue}>{customerInfo.email.replace('mailto:', '')}</Text></View>
                <View style={styles.infoColRight}><Text style={styles.infoLabel}>Closure date:</Text><Text style={styles.infoValue}>{customerInfo.closureDate}</Text></View>
            </View>
            <View style={styles.addressRow}><Text style={styles.infoLabel}>Address:</Text><Text style={styles.addressValue}>{customerInfo.address}</Text></View>
          </View>
  
          <Text style={styles.sectionTitle1}>Loan Details</Text>
          <View style={styles.loanDetailsContainer}>
            <Text style={styles.lenderName}>Lender Name: {loanDetails.lenderName}</Text>
            <View style={styles.loanDetailsRow}>
                <View style={styles.loanDetailsCol}>
                    <Text style={styles.loanDetailsLabel}>Loan Amount:</Text>
                    <Text style={styles.loanDetailsValue}>{loanDetails.loanAmount}</Text>
                </View>
                 <View style={styles.loanDetailsCol}>
                    <Text style={styles.loanDetailsLabel}>Tenure of Loan:</Text>
                    <Text style={styles.loanDetailsValue}>{loanDetails.tenure}</Text>
                </View>
            </View>
             <View style={styles.loanDetailsRow}>
                <View style={styles.loanDetailsCol}>
                    <Text style={styles.loanDetailsLabel}>Remaining Due:</Text>
                    <Text style={styles.loanDetailsValue}>{loanDetails.totalDue}</Text>
                </View>
                 <View style={styles.loanDetailsCol}>
                    <Text style={styles.loanDetailsLabel}>Principal Outstanding:</Text>
                    <Text style={styles.loanDetailsValue}>{loanDetails.principalOutstanding}</Text>
                </View>
            </View>
          </View>
  
          <Text style={[styles.sectionTitle, {marginTop: 20}]}>Statement of Account</Text>
          <View style={styles.table}>
              <TableHeader />
              {/* Map over the entire dataset. No more slicing. */}
              {statementData?.map((item) => <TableRow key={item.emiNo} item={item} />)}
          </View>
  
          {/* Terms and conditions now flow naturally after the table. */}
          {/* <View style={styles.termsSection} wrap={false}>
            <Text style={styles.termsTitle}>Terms & Conditions</Text>
            <Text style={styles.termsText}><Text style={styles.termsBold}>1. Charges levied in case of non-repayment of an EMI on the scheduled date:</Text></Text>
            <Text style={styles.termsText}><Text style={styles.termsBold}>(i) EMI Bounce Charge (INR):</Text> This EMI Bounce charge will only apply on the first occurrence of the EMI repayment default. It shall be calculated at the lower of: (i) 4% of the principal amount forming part of the bounced EMI or (ii) Rs.500</Text>
            <Text style={styles.termsText}><Text style={styles.termsBold}>(ii) Penal Charges (INR):</Text> Penal Charges for a continuing default in repayment of EMI from day 2 and continuing for maximum of 180 days shall be calculated at an annualized rate of 36% p.a which will be applicable per day on principal overdue* amount *round to nearest rupee.</Text>
            <Text style={styles.termsText}>No penalty charges will be levied beyond the period of 180 days if an EMI continues to remain outstanding beyond such period of 180 days. For the avoidance of doubt, it is hereby clarified that the EMI Bounce Charges and Penal Charges will be calculated on the principal overdue amount only and shall be levied distinctly and separately from the components of the principal overdue amount and the loan interest. These charges are not added to the rate of interest against which the loan has been advanced and are also not subject to any further interest. Please note that these charges are calculated in a manner so as to be commensurate to the default and are levied in a non-discriminatory manner for this loan product.</Text>
            <Text style={styles.termsText}><Text style={styles.termsBold}>2.</Text> In case of updates in the payment status post statement generation date, the same will be reflected in the subsequent statements of accounts.</Text>
          </View> */}
          
          <Footer />
        </Page>
      </Document>
    );
};
  
export default Statement;